import { render, staticRenderFns } from "./ConnectAdyenPlatformAccount.vue?vue&type=template&id=2b97c2e2"
import script from "./ConnectAdyenPlatformAccount.vue?vue&type=script&lang=js"
export * from "./ConnectAdyenPlatformAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports